import z from 'zod';
import { newPasswordSchema } from './validation';
import { phoneSchema } from './others';

export const signupSchema = z
  .object({
    // store_category: z.enum(['pharmacy_store', 'supermarket']),
    role_type: z.literal('store_owner'),
    first_name: z
      .string({ message: 'First name is required' })
      .min(1, { message: 'First name is required' }),
    last_name: z
      .string({ message: 'Last name is required' })
      .min(1, { message: 'Last name is required' }),
    email: z
      .string({ message: 'Email is required' })
      .email({ message: 'Email is required' })
      .trim()
      .toLowerCase(),
    password: newPasswordSchema,
    confirm_password: z.string({ message: 'Confirm password' }),
    phone: phoneSchema,
    token: z
      .string({ message: 'Token is required' })
      .min(6, { message: 'Token must be 6 digits' })
      .max(6, { message: 'Token must be 6 digits' }),
    ref_code: z.string().optional(),
    // store_name: z.string().min(1, { message: 'Store name is required' }),
    // store_address: z.string().optional(),
    // store_license: z.instanceof(File).optional(),
    pay_account: z.string().optional(),
    bank: z.string().optional(),
    account_name: z.string().optional(),
    account_number: z.string().optional(),
  })
  .refine((data) => data.password == data.confirm_password, {
    path: ['confirm_password'],
    message: 'Passwords do not match',
  });
